import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=4026d117"
import script from "./Captcha.vue?vue&type=script&lang=ts"
export * from "./Captcha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports